// HYK-1109: cooldown guard for the Contribute sheet auto-opened after a new subscribe.
// Only gates the AUTO-triggered open — manual "Contribute" taps and deep links are unaffected.

// Kill-switch: disable the HYK-1109 auto-open-after-subscribe prompt everywhere.
// Checked by useAutoContributePrompt's evaluate() directly — NOT here, since this function
// only answers "was it dismissed recently," and forcing that false would remove a block
// condition instead of adding one.
export const DISABLE_AUTO_CONTRIBUTE_PROMPT = false;

const COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

function getStorageKey(subscriberId, creatorId) {
  return `contribute-prompt-dismissed-${subscriberId}-${creatorId}`;
}

/**
 * True if this subscriber dismissed the auto-prompt for this creator within the cooldown window.
 */
export function wasContributePromptDismissedRecently(subscriberId, creatorId) {
  if (!subscriberId || !creatorId) return false;
  try {
    const dismissedAt = Number(localStorage.getItem(getStorageKey(subscriberId, creatorId)));
    return !!dismissedAt && Date.now() - dismissedAt < COOLDOWN_MS;
  } catch (error) {
    console.error('Error checking contribute prompt cooldown:', error);
    return false;
  }
}

/**
 * Records that the auto-triggered sheet was dismissed, starting the cooldown.
 */
export function markContributePromptDismissed(subscriberId, creatorId) {
  if (!subscriberId || !creatorId) return;
  try {
    localStorage.setItem(getStorageKey(subscriberId, creatorId), String(Date.now()));
  } catch (error) {
    console.error('Error marking contribute prompt dismissed:', error);
  }
}
